import React, { useEffect, useState } from "react";
import Header from "../../../Components/Header/Header";
import Footer from "../../../Components/Footer/Footer";
import AddPointsComponent from "../../../Components/AdminComponent/AddPointsComponent/AddPointsComponent";
import { Apiurl, GetLocalStorageParsed, parseData } from "../../utils/page";
import axios from "axios";
import AdminSidebar from "../../../Components/AdminComponent/AdminSidebar/AdminSidebar";
import AdminHeader from "../../../Components/AdminComponent/AdminHeader/AdminHeader";
import { toast } from "react-toastify";

const AddPoints = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [profileImage, setProfileImage] = useState();
  const [formData, setFormData] = useState({
    money: "",
    points: "",
  });
  const [pointSLabData, setPointSlabData] = useState();

  const getPointSlab = () => {
    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/Admin/GetAllMoneyToPointsSlabs`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setPointSlabData(data);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    getPointSlab();
  }, []);
  const handleAddPointSlab = () => {
    const data = {
      money: formData?.money,
      points: formData?.points,
      image: profileImage?.replace(/^data:image\/\w+;base64,/, ""),
    };

    const options = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/Admin/SaveAddMoneySlabs`,
    };
    axios(options)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        setFormData({
          ...formData,
          money: "",
          points: "",
        });
        getPointSlab();
        document.getElementById("image-upload").value = "";
      })
      .catch((error) => {});
  };

  const handleImageUpload = (e) => {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setProfileImage(reader.result);
    };
    reader.readAsDataURL(files[0]);
  };
  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      <AdminHeader />
      <div className="row col-lg-12">
        <AdminSidebar />
        <div className="col-lg-10 right_content">
          <AddPointsComponent
            handleAddPointSlab={handleAddPointSlab}
            handleImageUpload={handleImageUpload}
            setFormData={setFormData}
            formData={formData}
            pointSLabData={pointSLabData}
          />
        </div>
      </div>
    </div>
  );
};

export default AddPoints;
